import React, { useEffect, useState } from "react";
import { CmpDatePickerField001V1 } from "../../Component/Common/ToolBox/ToolBoxV1";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";

import moment from "moment";
import {
  IMPURTrip_Summary_001,
  PackingUnit_Buyer_getrowsAPI,
} from "../../Server/ApiV2";
import {
  exportToExcel,
  fAlertToast,
  fcheck_null_undefine_replace_empty,
  getStatusStyleV3,
} from "../../Utility/Utilitys";
import ItemCreationSidenav from "./ItemCreationSidenav";
import AutocompleteCheckboxFixSizeUid from "./AutocompleteCheckboxFixSizeUid";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import { use } from "react";

const ItemCreationSummary = () => {
  const xMediaQuery = useMediaQuery("(max-width:950px)");

  const [open, setOpen] = useState(false);
  const [buyerdata, setBuyerData] = useState([]);
  const [summaryData, setSummaryData] = useState([]);
  const [filterObj, setFilterObj] = useState({
    dateFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      1
    ).toISOString(),
    dateTo: new Date(),
    Buyer: [],
  });
  const [selectedRow, setSelectedRow] = useState(null);

  const handleRowClick = (params) => {
    setSelectedRow(params?.row);
    setOpen(true);
  };

const fBuyer = async () => {
  try {
    const result = await PackingUnit_Buyer_getrowsAPI();
    if (result?.status === 200) {
      const data = result?.data?.Buyer ?? [];
      setBuyerData(data);
      const allUids = data.map((x) => x.UID);
      setFilterObj((prev) => ({
        ...prev,
        Buyer: allUids,
      }));
      return allUids;   // ➜ return UIDs
    }else{
          fAlertToast("FAILED", result?.response?.data?.error|| result?.message)
    }
  } catch (error) {
  }

  return []; 
};

const fonLoad = async (buyersParam) => {
  try {
    const buyers = buyersParam ?? filterObj?.Buyer ?? [];
    const obj = {
      FromDate: moment(filterObj?.dateFrom).format("MM/DD/YYYY"),
      ToDate: moment(filterObj?.dateTo).format("MM/DD/YYYY"),
      Buyer: buyers.toString(),
    };
    let FinalObj = fcheck_null_undefine_replace_empty(obj);
    const resp = await IMPURTrip_Summary_001(FinalObj);
    if (resp?.status === 200) {
      setSummaryData(resp?.data?.ResultSet || []);
    } else {
      fAlertToast("FAILED", resp?.response?.data?.message || resp?.message);
    }
  } catch (error) {}
};


useEffect(() => {
  const init = async () => {
    const buyers = await fBuyer();  // get UIDs
    if(buyers?.length === 0) return;
    await fonLoad(buyers);          // pass them to first load
  };
  init();
}, []);


  return (
    <div className="div-container p-2">
      <Box
        sx={{
          width: "100%",
        }}
      >
        <Typography
          variant="h6"
          gutterBottom
          color={"primary"}
          sx={{ fontWeight: 600, mt: 0.5 }}
        >
          Item Creation
        </Typography>
        <Grid container spacing={2} mt={1} p={0.5}>
          <Grid item xs={6} md={2} sm={6}>
            <CmpDatePickerField001V1
              xName="From Date"
              xLabelText="From Date"
              xValue={filterObj?.dateFrom}
              xOnChange={(newValue) => {
                setFilterObj((prev) => ({
                  ...prev,
                  dateFrom: newValue?.$d ?? newValue,
                }));
              }}
            />
          </Grid>

          <Grid item xs={6} md={2} sm={6}>
            <CmpDatePickerField001V1
              xName="To Date"
              xLabelText="To Date"
              xValue={filterObj?.dateTo}
              xOnChange={(newValue) => {
                setFilterObj((obj) => ({
                  ...obj,
                  dateTo: newValue.$d,
                }));
              }}
            />
          </Grid>

          <Grid item xs={12} sm={9} md={4}>
            <AutocompleteCheckboxFixSizeUid
              options={buyerdata ?? []}
              xValue={filterObj?.Buyer}
              label="Buyer"
              xtabIndex="Buyer"
              setValue={setFilterObj}
              // setError={setErrors}
              objName="Buyer"
              autoComplete="off"
              sx={{
                "&:.MuiOutlinedInput-root": {
                  padding: "2px",
                },
              }}
              placeholder="Search buyer"
            />
          </Grid>

          <Grid item xs={10} sm={2} md={3.4} textAlign={"right"}>
            <Button variant="contained" onClick={() => fonLoad()} size="small">
              Load
            </Button>
          </Grid>
          <Grid item xs={2} sm={1} md={0.6} textAlign={'center'}>
            <Tooltip title="Export CSV" sx={{ mt: 0.5 }}>
              <IconButton
                color="primary"
                onClick={() => {
                  exportToExcel(summaryData, "ItemCreation", "ItemCreation");
                }}
                size="small"
              >
                <DownloadOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
        <Box
          sx={{
            height: {
              xs: "62vh",
              sm:"68vh",
              md: "75vh",
              xl: "78vh",
            },
            mt: 2,
            
          }}
        >
          <DataGridPro
            rowHeight={30}
            headerHeight={40}
            rows={summaryData}
            getRowId={(v) => v.TripId}
            columns={[
              {
                field: "TripId",
                headerName: "Trip Id",
                width: xMediaQuery ? 60 : 60,
                align: "center",
                headerAlign: "center",
              },
              
              {
                field: "Name",
                headerName: " Trip Name",
                flex: 1,
                minWidth: 250,
              },
              {
                field: "NoOfExcelCount",
                headerName: "Trans Count",
                width: xMediaQuery ? 60 : 100,
                align: "center",
                headerAlign: "center",
              },
              {
                field: "Expt_From",
                headerName: "Expected From",
                width: xMediaQuery ? 120 : 120,
                valueFormatter: ({ value }) =>
                  moment(value).format("DD/MM/YYYY") == "Invalid date"
                    ? ""
                    : moment(value).format("DD/MM/YYYY"),
                align: "center",
                headerAlign: "center",
              },
              {
                field: "Expt_To",
                headerName: "Expected To",
                width: xMediaQuery ? 120 : 120,
                valueFormatter: ({ value }) =>
                  moment(value).format("DD/MM/YYYY") == "Invalid date"
                    ? ""
                    : moment(value).format("DD/MM/YYYY"),
                align: "center",
                headerAlign: "center",
              },

              {
                field: "BuyerName",
                headerName: "Buyer",
                width: 200,
                align: "left",
                headerAlign: "left",
              },
            ]}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "mui-even-row"
                : "mui-odd-row"
            }
            sx={{
              border: 1,
              borderColor: "primary.light",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#0d73bb",
                color: "white",
              },
            }}
            hideFooter
            onRowDoubleClick={handleRowClick}
          />
        </Box>
        <ItemCreationSidenav
          open={open}
          onClose={() => setOpen(false)}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          loadSummary={fonLoad}
          filterObj={filterObj}
          setFilterObj={setFilterObj}
          summaryData={summaryData}
          setSummaryData={setSummaryData}
        />
      </Box>
    </div>
  );
};

export default ItemCreationSummary;





















